import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useOrderService from "../../../hooks/useOrderService";
import useBasketService from "../../../hooks/useBasketService";
import { useBasketContext } from "../../../context/Basket/BasketContext";
import { WfsPaymentRequiredResponse } from "../../../types/Wfs/WfsResponse";
import LoadingSpinner from "../../Loading/LoadingSpinner";
import { useThemeContext } from "../../theme/ThemeContext";
import { Theme } from "../../../constant/Theme";

interface RenewalRenewCurrentProps {
  orderId: string;
  orderItemId: string;
}

const RenewalRenewCurrent = ({
  orderId,
  orderItemId,
}: RenewalRenewCurrentProps) => {
  const navigate = useNavigate();
  const orderService = useOrderService();
  const basketService = useBasketService();
  const { setBasket } = useBasketContext();

  const { theme } = useThemeContext();
  const spinnerColor = theme === Theme.DARK ? "text-white" : "text-primary";

  useEffect(() => {
    const run = async () => {
      const result = (await orderService.ReOrder(
        orderId,
        orderItemId,
      )) as WfsPaymentRequiredResponse;
      const basket = await basketService.AddToBasket(result.id);
      setBasket(basket);
      navigate("/basket");
    };

    run();
  }, []);

  return <LoadingSpinner message="Reordering Data..." textColor={spinnerColor} />;
};

export default RenewalRenewCurrent;
